import { inject, injectable } from 'inversify';
import SlackNotificationsRepository from 'src/features/slack/data/SlackNotificationsRepository';
import { SendSlackMessageRequest } from 'src/features/slack/data/service/SlackNotificationsService.types';

@injectable()
class SendSlackAppNotificationUseCase {
  @inject(SlackNotificationsRepository)
  private slackNotificationsRepository!: SlackNotificationsRepository;

  async execute(params: Omit<SendSlackMessageRequest, 'channel'>) {
    return await this.slackNotificationsRepository.send({
      channel: 'tech-app-notifications',
      attachments: params.attachments,
    });
  }
}

export default SendSlackAppNotificationUseCase;
